<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="column" fxLayoutGap="1rem" class="nvc-footer">
  <mat-divider></mat-divider>
  <div
    fxLayout="row"
    fxLayout.lt-sm="column"
    class="footerC"
    fxLayoutAlign="space-between"
    class="ws-footer-padding"
  >
    <div fxFlex="30" fxLayout="column" class="footerlogo" fxLayoutGap="10px">
      <div class="footer-img">
        <img
          *ngIf="whiteShopLogo"
          class="nvc-whiteshop-logo"
          [src]="whiteShopLogo"
          alt="whiteshopLogo"
        />
      </div>
      <div
        class="nvc-footer-text-quote"
        *ngIf="
          !(footerText && footerText.length) &&
          isClient === 'highlineunitedmarketplace'
        "
      >
        Highline United is a footwear company devoted to the design,
        manufacture, and distribution of branded and private label footwear. We
        make high quality shoes for many of the best brands in the world.
      </div>
      <div
        class="nvc-footer-text-quote"
        *ngIf="
          (!isClient ||
            (isClient && isClient !== 'highlineunitedmarketplace')) &&
          !(footerText && footerText.length)
        "
      >
        Offers shoppable live video streams to all your favourite stores in
        highly engaging and conversion-boosting experience.
      </div>
      <div
        class="nvc-footer-text-quote ws-text-style"
        *ngIf="footerText && footerText.length"
      >
        {{ footerText }}
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-around"
      fxFlex="60"
      fxFlex.lt-sm="100"
      *ngIf="
        isClient === 'highlineunitedmarketplace' &&
        !(addresses && addresses.length)
      "
    >
      <div fxLayout="row" fxFlex="30" fxLayoutGap="5px">
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div>CORPORATE HEADQUARTERS</div>
          <small> 980 Washington Street, </small>
          <small> Suite 216, </small>
          <small> Dedham, MA 02026 </small>
          <small> 617-333-3235 </small>
        </div>
      </div>
      <div fxLayout="row" fxLayout.lt-sm="column" fxFlex="30" fxLayoutGap="5px">
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div>SHOWROOM</div>
          <small> 530 W 25<sup>th</sup> Street, </small>
          <small> Penthouse, </small>
          <small> New York, NY 10001 </small>
        </div>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-around"
      fxFlex="60"
      fxFlex.lt-sm="100"
      *ngIf="isClient === 'jdx' && !(addresses && addresses.length)"
      fxLayoutGap.lt-sm="10px"
    >
      <div fxLayout="row" fxFlex="30" fxLayout.lt-sm="column" fxLayoutGap="5px">
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div>NEW YORK</div>
          <small> 84 Wooster St., Suite 203 </small>
          <small> New York, NY 10012 </small>
          <small> USA </small>
        </div>
      </div>
      <div fxLayout="row" fxLayout.lt-sm="column" fxFlex="30" fxLayoutGap="5px">
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div>LONDON</div>
          <small> Soho Works White City </small>
          <small> 2 Television Centre, </small>
          <small> London W12 7FR </small>
          <small> UK </small>
        </div>
      </div>
      <div fxLayout="row" fxFlex="30" fxLayout.lt-sm="column" fxLayoutGap="5px">
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div>BANGALORE</div>
          <small> No 80, Hulkul Ascent, 2nd Cross, </small>
          <small> Lavelle Road, Shanthala Nagar, Ashok Nagar, </small>
          <small> Bangalore, Karnataka 560001 </small>
          <small> INDIA </small>
        </div>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-around"
      fxFlex="60"
      *ngIf="isClient === 'srsm'"
      class="ws-info-section"
      fxLayoutGap.lt-sm="20px"
    >
      <div fxLayout="column" fxFlex="35" fxLayoutGap="10px">
        <b> Information </b>
        <div fxLayout="column" fxLayoutGap="5px">
          <small> Appointments </small>
          <small> Find a store </small>
          <small> Newsletter </small>
          <small> Become a member </small>
          <small> Site feedback </small>
        </div>
      </div>
      <div
        fxLayout="column"
        fxFlex="45"
        fxLayoutGap="10px"
        class="nvc-contact-info"
      >
        <b> Contact </b>
        <div fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="5px">
          <small> SR Shopping Mall, </small>
          <small> Vuda Layout, </small>
          <small> Madhavadhara </small>
          <small> Visakhapatnam </small>
          <small> Andhra Pradesh 530009 </small>
        </div>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-around"
      fxFlex="60"
      fxLayoutGap.lt-sm="20px"
      *ngIf="!isClient && !(addresses && addresses.length)"
    >
      <div
        fxLayout="column"
        fxFlex="40"
        fxLayoutGap="10px"
        class="ws-info-section"
      >
        <b> Information </b>
        <div fxLayout="column" fxLayoutGap="5px">
          <small> Appointments </small>
          <small> Find a store </small>
          <small> Newsletter </small>
          <small> Become a member </small>
          <small> Site feedback </small>
        </div>
      </div>
      <div
        fxLayout="column"
        fxFlex="60"
        fxLayoutGap="10px"
        class="nvc-contact-info"
      >
        <b> Contact </b>
        <div fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="5px">
          <small> nVipani Technology Solutions Private Limited, </small>
          <small>
            854/1, NMS Arcade, 1st Floor, 8th B Cross, 6th Main Rd, Opp LIC
            Colony,
          </small>
          <small> New Tippasandra, Bengaluru, Karnataka - 560075 </small>
          <small> Phone: 080 4125 2425 </small>
          <small> Email: info@nvipani.com </small>
        </div>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-around"
      fxFlex="60"
      fxFlex.lt-sm="100"
      *ngIf="addresses && addresses.length"
    >
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        *ngFor="let eachAddress of addresses"
        fxFlex="30"
        class="ws-text-style ws-mb-1rem"
      >
        <mat-divider [vertical]="true" fxHide.lt-sm></mat-divider>
        <mat-divider fxHide.gt-xs class="nvc-margin-bottom"></mat-divider>
        <div fxLayout="column" fxLayoutGap="5px">
          <div class="ws-text-margin">
            {{ eachAddress.title }}
          </div>
          <small class="ws-text-margin">
            {{ eachAddress.addressLine }}
          </small>
          <!-- <small>
              {{ eachAddress.city }}
            </small>
            <small>
              {{ eachAddress.state }}
            </small>
            <small>
              {{ eachAddress.country }}
            </small>
            <small>
              {{ eachAddress.pinCode }}
            </small> -->
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isClient !== 'highlineunitedmarketplace'">
    <div
      class="nvc-social-icons nvc-margin-top"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <a
        class="ws-outline-none"
        [attr.href]="faceBookLink"
        *ngIf="faceBookLink"
        target="_blank"
        rel="noopener noreferrer"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="fbFooterLogoColored"
          alt="fbLogo"
          [ngClass]="
            isMobileDevice()
              ? 'nvc-social-logo-img-mobile'
              : 'nvc-social-logo-img'
          "
        />
      </a>
      <a
        class="ws-outline-none"
        [attr.href]="twitterLink"
        target="_blank"
        *ngIf="twitterLink"
        rel="noopener noreferrer"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="twitterFooterLogoColored"
          alt="twitterLogo"
          [ngClass]="
            isMobileDevice()
              ? 'nvc-social-logo-img-mobile'
              : 'nvc-social-logo-img'
          "
        />
      </a>
      <a
        class="ws-outline-none"
        [attr.href]="linkedInLink"
        *ngIf="linkedInLink"
        target="_blank"
        rel="noopener noreferrer"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="linkedInFooterLogoColored"
          alt="linkedInLogo"
          [ngClass]="
            isMobileDevice()
              ? 'nvc-social-logo-img-mobile'
              : 'nvc-social-logo-img'
          "
        />
      </a>
      <a
        class="ws-outline-none"
        [attr.href]="instaGramLink"
        *ngIf="instaGramLink"
        target="_blank"
        rel="noopener noreferrer"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="instagramFooterLogoColored"
          alt="instagramLogo"
          [ngClass]="
            isMobileDevice()
              ? 'nvc-social-logo-img-mobile'
              : 'nvc-social-logo-img'
          "
        />
      </a>
      <a
        class="ws-outline-none"
        [attr.href]="youTubeLink"
        *ngIf="youTubeLink"
        target="_blank"
        rel="noopener noreferrer"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="youTubeFooterLogoColored"
          alt="youtubeLogo"
          [ngClass]="
            isMobileDevice()
              ? 'nvc-social-logo-img-mobile'
              : 'nvc-social-logo-img'
          "
        />
      </a>
    </div>
  </div>
  <div *ngIf="isClient === 'highlineunitedmarketplace'">
    <div style="margin-left: 30px" fxLayout="row" fxLayoutGap="10px">
      <a
        href="https://www.highlineunited.com/"
        style="
          width: 27px;
          height: 27px;
          background: #28a4dd 0% 0% no-repeat padding-box;
          border-radius: 20px;
          position: absolute;
        "
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="assets/icons/global.png"
          style="
            width: 17px;
            height: 17px;
            margin-left: 5px;
            margin-bottom: -3px;
          "
        />
      </a>
      <p class="footerlink footerwebsite" style="padding-left: 30px">
        www.highlineunited.com
      </p>
    </div>
  </div>
  <div class="nvc-footer-text">
    <div
      *ngIf="isUserConsumer()"
      (click)="redirectPoweredBy()"
      class="nvc-powered-by ws-cursor-pointer"
    >
      <span class="nvc-margin-powered-by">Powered by </span>
      <span>SHOP</span>
      <span class="nvc-logo-blue">CONNECT</span>
    </div>

    <div *ngIf="!isClient">
      NVIPANI TECHNOLOGY SOLUTIONS PRIVATE LIMITED - &copy;
      {{ currentYear }} ALL RIGHTS RESERVED
    </div>
    <div *ngIf="isClient === 'highlineunitedmarketplace'">
      &copy; AD2PRO MEDIA SOLUTIONS PVT LTD. ALL RIGHTS RESERVED
    </div>
    <div *ngIf="isClient === 'jdx'">
      &copy; AD2PRO MEDIA SOLUTIONS PVT LTD. ALL RIGHTS RESERVED
    </div>
    <div *ngIf="isClient === 'srsm'">
      NVIPANI TECHNOLOGY SOLUTIONS PRIVATE LIMITED - &copy;
      {{ currentYear }} ALL RIGHTS RESERVED
    </div>
  </div>
</div>
